import basePage from "@/components/BasePage/basepage.vue";
let mixin={
    components: {
        basePage
      },
    data(){
      return{
        pageState: {
            state: 'loading',
            message: ''
          },
      };
    },
    methods:{
       setPageState(state, message) {
        this.pageState.state = state;
        this.pageState.message = message;
      }
    }
  };
  export default mixin;


// WEBPACK FOOTER //
// ./src/mixins/page-mixer.js